import { PlusIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

export default function SectionButton({ isActive, onClick, title }) {
  return (
    <>
      <button
        onClick={(e) => onClick(e)}
        className={clsx(
          isActive ? ' bg-blue-500 text-white' : 'bg-blue-50 text-blue-500',
          'mt-3 ml-5 flex rounded-xl border-2 border-blue-500 bg-blue-50 px-2 py-0.5 text-sm font-semibold ring-blue-200 hover:bg-blue-500 hover:text-white'
        )}
      >
        <PlusIcon className="my-auto h-4 w-4 " />
        <span className="mx-1 text-sm">{title}</span>
      </button>
    </>
  );
}
